// @format
import React from 'react';
// import { compose, withHandlers } from 'recompose';
// import { scroller } from 'react-scroll';
import Header from 'modules/components/Header';

import './App.css';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DownloadBtnVisibleContext from 'modules/context/DownloadBtnVisibleContext';
import Form from 'modules/components/Form';
import IntroSection from 'modules/components/IntroSection';
import SearchIntro from 'modules/components/SearchIntro';
import MessageIntro from 'modules/components/MessageIntro';
import DownloadButton from 'modules/components/DownloadButton';
// import withPlatformStateHandler from 'modules/hocs/withPlatformStateHandler';

const showBetaForm = false;

const App = ({ platform, setPlatform }) => (
  <MuiThemeProvider>
    <DownloadBtnVisibleContext.Provider value={{ isVisible: true }}>
      <div className="App">
        <Header className="App-Header">
          <DownloadBtnVisibleContext.Consumer>
            {({ isVisible }) =>
              !isVisible && (
                <div className="Header-Download">
                  <DownloadButton className="icon-view" idPrefix="header" />
                </div>
              )
            }
          </DownloadBtnVisibleContext.Consumer>
        </Header>
        <IntroSection />
        <SearchIntro />
        <MessageIntro />
        {showBetaForm && (
          <section className="App-form-section" id="form">
            <div className="App-form">
              <Form platform={platform} setPlatform={setPlatform} />
            </div>
          </section>
        )}
        <div className="App-Footer">
          Copyright © 2019 TouShih Technology Ltd. All rights reserved.
        </div>
      </div>
    </DownloadBtnVisibleContext.Provider>
  </MuiThemeProvider>
);

// const enhance = compose(
//   withPlatformStateHandler,
//   withHandlers({
//     onClickDownLoad: props => event => {
//       event.preventDefault();
//       scroller.scrollTo('form', {
//         duration: 1000,
//         spy: true,
//         smooth: 'easeInOutQuart',
//       });
//       props.setPlatform(event.target.dataset.name);
//     },
//   }),
// );

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js